// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile-first: below \`md\` the table is a bare three-column list (the top
   three live in <Podium>), so it drops the card chrome, zebra and min-width.
   Everything the desktop table adds back lives in the min-width block below. */
.TraderTable_card__qxct7 {
  background-color: transparent;
  border: none;
  border-radius: 0;
  /* Mobile only: capped height so the list scrolls in place instead of pushing
     the calculator far down the page. \`table-responsive\` supplies overflow-x. */
  max-height: 32rem;
  overflow-y: auto;
}

.TraderTable_table__3Me3Y {
  --bs-table-bg: transparent;
  --bs-table-color: var(--text);
  color: var(--text);
  margin-bottom: 0;
}

.TraderTable_th__Brzgc {
  /* Opaque, because rows scroll underneath it. !important because Bootstrap's
     \`.table > :not(caption) > * > *\` outranks a bare class selector. */
  background-color: var(--bg) !important;
  border-bottom: none;
  color: var(--text-secondary) !important;
  font-size: 0.9375rem;
  font-weight: 700;
  padding: 0.75rem 0.5rem !important;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.TraderTable_td__0dPX9 {
  background-color: transparent;
  border: none;
  color: var(--text);
  font-size: 0.9375rem;
  padding: 1rem 0.5rem !important;
  vertical-align: middle;
  white-space: nowrap;
}

.TraderTable_rankCell__0TpUZ {
  font-variant-numeric: tabular-nums;
}

.TraderTable_empty__W4qvZ {
  color: var(--text-muted);
  padding: 2.5rem 1rem !important;
  white-space: normal;
}

.TraderTable_rankTop__Jscxq {
  color: var(--accent-strong);
  font-weight: 600;
}

.TraderTable_positive__AsBHs {
  color: var(--positive) !important;
}

.TraderTable_sortButton__8G2Qa {
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  padding: 0;
}

.TraderTable_sortButton__8G2Qa:hover,
.TraderTable_sortActive__ipwZA {
  color: var(--text-secondary) !important;
}

@media (min-width: 768px) {
  .TraderTable_card__qxct7 {
    background-color: var(--surface);
    border: 1px solid var(--border);
    border-radius: 0.5rem;
    /* Desktop shows every row: no cap, no vertical scroll. */
    max-height: none;
    overflow-y: visible;
  }

  .TraderTable_table__3Me3Y {
    min-width: 46rem;
  }

  .TraderTable_th__Brzgc {
    /* Nothing scrolls under it here, so it needn't stick. */
    position: static;
    background-color: var(--surface-alt) !important;
    border-bottom: 1px solid var(--border);
    color: var(--text-secondary) !important;
    font-size: 0.875rem;
    font-weight: 600;
    padding: 1rem 1.75rem !important;
  }

  .TraderTable_td__0dPX9 {
    font-size: 0.875rem;
    padding: 1rem 1.75rem !important;
  }

  /* Shade whole rows rather than cells so the zebra reads as one band. */
  .TraderTable_table__3Me3Y tbody tr:nth-child(even) .TraderTable_td__0dPX9 {
    background-color: var(--surface-alt);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TraderTable/TraderTable.module.css"],"names":[],"mappings":"AAAA;;+EAE+E;AAC/E;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB;gFAC8E;EAC9E,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;uEACqE;EACrE,sCAAsC;EACtC,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE;IACE,gCAAgC;IAChC,+BAA+B;IAC/B,qBAAqB;IACrB,yDAAyD;IACzD,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wDAAwD;IACxD,gBAAgB;IAChB,+CAA+C;IAC/C,sCAAsC;IACtC,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA,uEAAuE;EACvE;IACE,oCAAoC;EACtC;AACF","sourcesContent":["/* Mobile-first: below `md` the table is a bare three-column list (the top\n   three live in <Podium>), so it drops the card chrome, zebra and min-width.\n   Everything the desktop table adds back lives in the min-width block below. */\n.card {\n  background-color: transparent;\n  border: none;\n  border-radius: 0;\n  /* Mobile only: capped height so the list scrolls in place instead of pushing\n     the calculator far down the page. `table-responsive` supplies overflow-x. */\n  max-height: 32rem;\n  overflow-y: auto;\n}\n\n.table {\n  --bs-table-bg: transparent;\n  --bs-table-color: var(--text);\n  color: var(--text);\n  margin-bottom: 0;\n}\n\n.th {\n  /* Opaque, because rows scroll underneath it. !important because Bootstrap's\n     `.table > :not(caption) > * > *` outranks a bare class selector. */\n  background-color: var(--bg) !important;\n  border-bottom: none;\n  color: var(--text-secondary) !important;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  padding: 0.75rem 0.5rem !important;\n  white-space: nowrap;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.td {\n  background-color: transparent;\n  border: none;\n  color: var(--text);\n  font-size: 0.9375rem;\n  padding: 1rem 0.5rem !important;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.rankCell {\n  font-variant-numeric: tabular-nums;\n}\n\n.empty {\n  color: var(--text-muted);\n  padding: 2.5rem 1rem !important;\n  white-space: normal;\n}\n\n.rankTop {\n  color: var(--accent-strong);\n  font-weight: 600;\n}\n\n.positive {\n  color: var(--positive) !important;\n}\n\n.sortButton {\n  background: none;\n  border: none;\n  color: inherit;\n  font: inherit;\n  padding: 0;\n}\n\n.sortButton:hover,\n.sortActive {\n  color: var(--text-secondary) !important;\n}\n\n@media (min-width: 768px) {\n  .card {\n    background-color: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: 0.5rem;\n    /* Desktop shows every row: no cap, no vertical scroll. */\n    max-height: none;\n    overflow-y: visible;\n  }\n\n  .table {\n    min-width: 46rem;\n  }\n\n  .th {\n    /* Nothing scrolls under it here, so it needn't stick. */\n    position: static;\n    background-color: var(--surface-alt) !important;\n    border-bottom: 1px solid var(--border);\n    color: var(--text-secondary) !important;\n    font-size: 0.875rem;\n    font-weight: 600;\n    padding: 1rem 1.75rem !important;\n  }\n\n  .td {\n    font-size: 0.875rem;\n    padding: 1rem 1.75rem !important;\n  }\n\n  /* Shade whole rows rather than cells so the zebra reads as one band. */\n  .table tbody tr:nth-child(even) .td {\n    background-color: var(--surface-alt);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `TraderTable_card__qxct7`,
	"table": `TraderTable_table__3Me3Y`,
	"th": `TraderTable_th__Brzgc`,
	"td": `TraderTable_td__0dPX9`,
	"rankCell": `TraderTable_rankCell__0TpUZ`,
	"empty": `TraderTable_empty__W4qvZ`,
	"rankTop": `TraderTable_rankTop__Jscxq`,
	"positive": `TraderTable_positive__AsBHs`,
	"sortButton": `TraderTable_sortButton__8G2Qa`,
	"sortActive": `TraderTable_sortActive__ipwZA`
};
export default ___CSS_LOADER_EXPORT___;
